<template>
  <b-modal id="evangelioDia" size="lg" centered scrollable hide-footer modal-class="sd-modal" @show="getEvangelioDia">
    <template #modal-header>
      <img
        class="sd-modal-logo"
        :src="$store.getters.isDarkMode ? require('@/assets/img/logo_santo_domingo_dark.png') : require('@/assets/img/logo_santo_domingo.png')"
        :alt="$root.constantes.logo_nombre_sitio"
      />
      <button type="button" class="sd-modal-close" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <header class="ev-dia-head">
      <p class="sd-eyebrow">Palabra de Dios</p>
      <h2 class="ev-dia-title">Lecturas del día</h2>
      <p class="ev-dia-date">{{ fechaHoy }}</p>
    </header>

    <div class="ev-dia-tabs" role="tablist">
      <button
        v-for="t in tabs"
        :key="t.key"
        type="button"
        role="tab"
        class="ev-dia-tab"
        :class="{ 'is-active': tab === t.key }"
        :aria-selected="tab === t.key"
        v-track:ver_lecturas="{ pestana: t.key }"
        @click="tab = t.key"
      >
        <span class="material-symbols-outlined">{{ t.icon }}</span>
        {{ t.label }}
      </button>
    </div>

    <div v-if="loading && !contenido" class="ev-dia-loading">
      <div v-for="n in 5" :key="n" class="sd-skeleton" :style="{ height: '16px', width: n === 5 ? '60%' : '100%' }"></div>
    </div>
    <p v-else-if="!contenido" class="sd-empty">
      <span class="material-symbols-outlined">menu_book</span>
      No se han podido cargar las lecturas de hoy.
    </p>
    <div v-else class="sd-prose ev-dia-body" v-html="contenido"></div>
  </b-modal>
</template>

<script>
import axios from "@/directives/axios.js";

const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];
const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

export default {
  name: "evangelioDia",
  data() {
    return {
      tab: "evangelio",
      loading: false,
      tabs: [
        { key: "evangelio", label: "Evangelio", icon: "auto_stories" },
        { key: "lecturas", label: "Lecturas", icon: "menu_book" },
      ],
    };
  },
  computed: {
    fechaHoy() {
      const d = new Date();
      return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`;
    },
    contenido() {
      return this.tab === "evangelio" ? this.$store.getters.getEvangelioDia : this.$store.getters.getLecturaDia;
    },
  },
  mounted() {
    this.getEvangelioDia();
  },
  methods: {
    async getEvangelioDia() {
      if (this.$store.getters.getEvangelioDia || this.loading) return;
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      this.loading = true;
      try {
        const { data } = await axios.get(`/evangeliodia?fecha=${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`);
        const speech = data.evangelioDia.speech[0];
        this.$store.commit("changeEvangelioDia", speech.vangeloText || "");
        this.$store.commit("changeLecturaDia", speech.letturaText || "");
      } catch (e) {
        // Se muestra el mensaje de error en el modal
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.$bvModal.hide("evangelioDia");
    },
  },
};
</script>

<style scoped>
.ev-dia-head {
  margin-bottom: 20px;
  text-align: center;
}

.ev-dia-title {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: 1.7rem;
  font-weight: 700;
  color: var(--sd-text);
}

.ev-dia-date {
  margin: 6px 0 0;
  color: var(--sd-muted);
}

.ev-dia-date::first-letter {
  text-transform: uppercase;
}

.ev-dia-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  padding: 4px;
  border: 1px solid var(--sd-border);
  border-radius: 14px;
  background: var(--sd-surface-2);
}

.ev-dia-tab {
  display: inline-flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  font-weight: 600;
  color: var(--sd-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.ev-dia-tab .material-symbols-outlined {
  font-size: 20px;
  color: inherit;
}

.ev-dia-tab.is-active {
  background: var(--sd-surface);
  color: var(--sd-primary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.ev-dia-loading {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ev-dia-body {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.1rem;
}
</style>
